import { useQuery } from '@tanstack/react-query';
import {
  BalanceOperationControlsEntity,
  BalanceOperationControlsService,
} from 'services/openapi';

import { BalanceOperationControlsServiceKeys } from './constants';

export const useGetBalanceOperationControlsQuery = (
  enabled: boolean = true,
) => {
  const queryKey = [
    BalanceOperationControlsServiceKeys.GET_BALANCE_OPERATION_CONTROLS,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<BalanceOperationControlsEntity, Error>({
    queryKey,
    queryFn: () =>
      BalanceOperationControlsService.balanceOperationControlsControllerGetControls(),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
